import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'm-search-input',
  template: `
    <nz-input-group class="m-search-input-group" [nzSuffix]="suffixIconButton">
      <input nz-input type="text" [(ngModel)]="query" [placeholder]="placeholder" (keyup.enter)="onSearch()" />
    </nz-input-group>
    <ng-template #suffixIconButton>
      <i nz-icon class="m-search-input-group-btn" (click)="onSearch()">
        <svg
          t="1630049398692"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1946"
          width="16"
          height="16"
        >
          <path
            d="M437.504 56.32c206.272 0 373.504 169.6 373.504 378.752a380.48 380.48 0 0 1-88.32 244.608l70.4 71.424a60.992 60.992 0 0 1 59.904 16l88.96 90.304c24.064 24.384 24 64 0 88.32l-0.96 1.024a60.928 60.928 0 0 1-87.04 0l-89.024-90.304a63.04 63.04 0 0 1-15.808-60.672l-70.4-71.488a368.896 368.896 0 0 1-241.216 89.6C231.232 813.888 64 644.288 64 435.072 64 225.92 231.232 56.32 437.504 56.32z m0 63.104C265.6 119.424 126.272 260.736 126.272 435.072S265.6 750.72 437.504 750.72c171.904 0 311.232-141.312 311.232-315.648S609.408 119.424 437.504 119.424z"
            fill="#41464B"
            fill-opacity=".9"
            p-id="1947"
          ></path>
        </svg>
      </i>
    </ng-template>
  `
})
export class MSearchInputComponent {
  @Input() query = '';
  @Input() placeholder = '';

  @Output() readonly queryChange = new EventEmitter<string>();
  @Output() readonly search = new EventEmitter<string>();

  onSearch(): void {
    this.queryChange.emit(this.query);
    this.search.emit(this.query);
  }
}
